// extracted by mini-css-extract-plugin
export default {"WaitingPlayers":"WaitingPlayers_WaitingPlayers__6SNA7"};